import {
  productBackground,
  productDots,
  productDemo,
  productHd,
  productCalendar,
  productBlueFrame
} from "assets/images";
import { ranking, presentation, telescope, productEllipse, productEllipse2 } from "assets/icons";
import { ZuArrowRight } from "components";
import { useState } from "react";

const faq: Array<{
  question: string;
  answer: string;
}> = [
  {
    question: "How does the translation and transcription feature work?",
    answer: `Amet minim mollit non deserunt ullamco.Amet minim mollit non deserunt ullamco. Amet
minim mollit non deserunt ullamco.Amet minim mollit non deserunt ullamco. Amet minim
mollit non deserunt ullamco.Amet minim mollit non deserunt ullamco.`
  },
  {
    question: "Can I use Zumaridi for meetings with international participants who speak English?",
    answer: `Amet minim mollit non deserunt ullamco.Amet minim mollit non deserunt ullamco. Amet
minim mollit non deserunt ullamco.Amet minim mollit non deserunt ullamco. Amet minim
mollit non deserunt ullamco.Amet minim mollit non deserunt ullamco.`
  },
  {
    question: "How accurate are the translations and transcriptions?",
    answer: `Amet minim mollit non deserunt ullamco.Amet minim mollit non deserunt ullamco. Amet
minim mollit non deserunt ullamco.Amet minim mollit non deserunt ullamco. Amet minim
mollit non deserunt ullamco.Amet minim mollit non deserunt ullamco.`
  },
  {
    question: "What other features does Zumaridi offer besides  translation and transcription?",
    answer: `Amet minim mollit non deserunt ullamco.Amet minim mollit non deserunt ullamco. Amet
minim mollit non deserunt ullamco.Amet minim mollit non deserunt ullamco. Amet minim
mollit non deserunt ullamco.Amet minim mollit non deserunt ullamco.`
  }
];

const ProductsView = () => {
  const [open, setOpen] = useState(-1);

  const toggle = (index: number) => {
    if (index === open) {
      setOpen(-1);
    } else setOpen(index);
  };

  return (
    <div className="flex flex-col items-center min-h-screen">
      <img
        className="relative w-full md:top-[-50px] sm:top-[-30px] top-[-20px]"
        src={productBackground}
        alt="icons"
      />
      <section className="flex flex-col justify-center md:w-[70%] w-[90%] mb-11">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <p className="font-semibold text-left md:w-[40%] text-[1.5rem]">Video Conference</p>
          <p className="font-normal md:w-[60%] md:text-[2.5rem] text-[1.8rem] text-center md:text-right">
            Achieve more with the Zumaridi Video Conferencing
          </p>
        </div>
        <button className="flex gap-3 self-center items-center py-3 px-5 lg:mt-12 mt-6 rounded-md text-white bg-green">
          Start for free <ZuArrowRight />
        </button>
        <img
          className="absolute top-[230px] left-0 z-[-10] max-w-[120px]"
          src={productDots}
          alt="productsDots"
        />
      </section>
      <section className="mb-16">
        <img src={productDemo} alt="demo" />
      </section>
      <section className="md:w-[80%] w-[90%] text-center mb-16">
        <h1 className="text-[2rem] font-semibold mb-4">
          Create flexible work environment with your team
        </h1>
        <div className="flex flex-col justify-center sm:flex-row mt-8 text-left">
          <div className="rounded-md p-4 shadow-lg flex flex-col gap-2">
            <img className="w-[40px]" src={ranking} alt="ranking" />
            <p className="font-semibold">Manage Smartly</p>
            <p>
              Amet minim mollit non deserunt ullamco <br /> est sit aliqua . Exercitation veniam{" "}
              <br />
              consequat sunt nostrud amet.
            </p>
          </div>
          <div className="rounded-md p-4 shadow-lg flex flex-col gap-2">
            <img className="w-[40px]" src={telescope} alt="telescope" />
            <p className="font-semibold">Brainstorm with Ease</p>
            <p>
              Amet minim mollit non deserunt ullamco <br /> est sit aliqua . Exercitation veniam{" "}
              <br />
              consequat sunt nostrud amet.
            </p>
          </div>
          <div className="rounded-md p-4 shadow-lg flex flex-col gap-2">
            <img className="w-[40px]" src={presentation} alt="presentation" />
            <p className="font-semibold">Give Presentation</p>
            <p>
              Amet minim mollit non deserunt ullamco <br /> est sit aliqua . Exercitation veniam{" "}
              <br />
              consequat sunt nostrud amet.
            </p>
          </div>
        </div>
      </section>
      <section
        className="w-[100%] text-center mb-14 pt-10"
        style={{
          background: `url(${productEllipse}) right top no-repeat, url(${productEllipse2}) left bottom no-repeat`
        }}
      >
        <div className="w-[95%] text-center m-auto">
          <h2 className="text-[2rem] font-semibold mb-2">
            Advanced features to boost collaboration.
          </h2>
          <p>Amet minim mollit non deserunt ullamco est sit aliqua.</p>
          <div className="flex flex-col md:flex-row text-center md:text-left items-center gap-2 lg:gap-5 mt-4">
            <img className="md:w-1/2" src={productHd} alt="hd" />
            <div className="mb-8 md:w-2/4 ">
              <p className="font-semibold text-[1.5rem]">High quality video HD</p>
              <p>
                Amet minim mollit non deserunt ullamco est sit aliqua. <br /> Exercitation veniam
                consequat sunt nostrud amet.
              </p>
            </div>
          </div>
          <div className="flex flex-col-reverse md:flex-row text-center md:text-left items-center gap-2 lg:gap-5 mt-4">
            <div className="mb-8 md:w-2/4">
              <p className="font-semibold text-[1.5rem]">Natural language processor</p>
              <p>Communicate</p>
            </div>
            <img className="md:w-1/2" src={productBlueFrame} alt="hd" />
          </div>
          <div className="flex flex-col md:flex-row text-center md:text-left items-center gap-2 lg:gap-5 mt-4">
            <img src={productCalendar} className="md:w-1/2" alt="hd" />
            <div className="mb-8 md:w-2/4">
              <p className="font-semibold text-[1.5rem]">Calendar</p>
              <p>
                Schedule and manage virtual meetings with friends, colleagues, <br /> or clients
              </p>
            </div>
          </div>
          <div className="flex flex-col-reverse md:flex-row text-center md:text-left items-center gap-2 lg:gap-5 mt-4">
            <div className="mb-8 md:w-2/4">
              <p className="font-semibold text-[1.5rem]">Screen anotation</p>
              <p>
                Highlight key points with our annotation tool to engage your team <br /> with
                interactive presentations
              </p>
            </div>
            <img className="md:w-1/2" src={productBlueFrame} alt="hd" />
          </div>
          <div className="flex flex-col md:flex-row text-center md:text-left items-center gap-2 lg:gap-5 mt-4 mb-8">
            <img className="md:w-1/2" src={productBlueFrame} alt="hd" />
            <div className="mb-8">
              <div>
                <p className="font-semibold text-[1.5rem] md:w-2/4">Meeting Notes</p>
                <p>
                  Take and share auto-generated notes with your team in real-time to streamline your
                  workflow
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col p-10">
          <h2 className="font-normal text-[2rem]">With more collaborating features</h2>
          <button className="flex gap-3 self-center items-center py-3 px-5 mt-2 rounded-md text-white bg-green">
            Start for free <ZuArrowRight />
          </button>
        </div>
      </section>
      <section className="flex flex-col items-center w-full mb-32 mt-6">
        <p className="font-semibold text-[0.8rem]">FAQs</p>
        <h3 className="font-normal text-center text-[2rem] mb-8">Frequently asked questions</h3>
        <div className="flex flex-col gap-3 md:w-[50%] w-[90%] mt-4">
          {faq.map((item, index) => {
            return (
              <div
                key={index}
                className={`${open === index ? "bg-green-200/30" : "bg-white"} p-6 rounded-md`}
              >
                <div
                  onClick={() => {
                    toggle(index);
                  }}
                  className="flex justify-between cursor-pointer"
                >
                  <p className="font-semibold text-[1.2rem]">{item.question}</p>
                  <span>{open === index ? "-" : "+"}</span>
                </div>
                <p className={`${open === index ? "block" : "hidden"} text-gray mt-2 pt-3`}>
                  {item.answer}
                </p>
                <button
                  className={`${
                    open === index ? "block" : "hidden"
                  } flex gap-3 self-center text-[0.8rem] items-center my-4 py-2 px-4 rounded-full text-white bg-green`}
                >
                  Learn More
                </button>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default ProductsView;
